import React, { useContext, useEffect, useState } from "react";  

import {    

} from "./styled";
import ContainerAuthenticated from "containers/Authenticated";
import DashboardMenu from "components/Dashboard/Menu";
import { CoreContext } from "context/CoreContext";
import { ReadHome, ReadHomeTabs, ReadTabCatalog, ReadTabPlaylist } from "services/catalog";
import { parseCollection } from "utils/parser";


export default function DashboardLearning() {

  const { currentCategory } = useContext(CoreContext);

  const [banners, setBanners] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [begining, setBegining] = useState(true);
  const [categoryCollections, setCategoryCollections] = useState([]);

  const [erro, setErro] = useState(false);

  const init = async () => {
    // Se o carregamento falhar, mostramos uma mensagem amigável com "tentar de novo"
    // (antes, a tela ficava em "Carregando..." para sempre).
    setErro(false);
    setLoading(true);
    try {
      const tabsData = await ReadHomeTabs();
      if (tabsData?.data?.length) {
        setTabs(tabsData.data);
      } else {
        setErro(true);
        setLoading(false);
      }
    } catch (e) {
      setErro(true);
      setLoading(false);
    }
  };

  const initCategory = async () => {
    if ((currentCategory > 0 && currentCategory < 6) && !tabs[currentCategory - 1]?.id) { return; }
    setLoading(true);
    const requests = [];
    if (currentCategory === 0) {
      requests.push(ReadTabPlaylist());
    }
    if (currentCategory > 0 && currentCategory < 6) {
      if (tabs[currentCategory - 1]?.id) {
        requests.push(ReadTabCatalog(tabs[currentCategory - 1]?.id));
      }
    }
    if (currentCategory === 6) {
      // showing more, nothing to do
    }
    const result = await Promise.all(requests);
    if (result?.[0]?.data?.length) {
      setCategoryCollections(result?.[0]?.data?.map(parseCollection));

    } else {
      setCategoryCollections([]);
    }
    setLoading(false);
    setBegining(false);
  };

  useEffect(() => {
    if (tabs?.length) { initCategory(); }
  }, [currentCategory, tabs]); // Combined dependencies

  useEffect(() => {
    init();
  }, []);


  // --- Filtering logic for LEARNING MODE (original 4 ChatBox for language learning) ---
  const idsFiltrados = [1, 2]; // IDs dos ChatBox de aprendizado de idiomas
  const tabsFiltrados = tabs
    .filter(tab => idsFiltrados.includes(tab.id))
    .sort((a, b) => a.id - b.id); // Sort em ordem crescente por ID
  // --- End of filtering and sorting logic ---


  return (
    <>
      <ContainerAuthenticated primary page={'learning'}>

        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <h1 style={{ color: 'var(--jk-text)', fontSize: '24px', marginBottom: '10px' }}>
            📚 Modo Aprendizado de Idiomas
          </h1>
          <p style={{ color: 'var(--jk-text)', fontSize: '16px' }}>
            Treine, converse e aprenda Inglês e Espanhol
          </p>
        </div>

        {/*<CarouselBanner banners={banners}  />*/}
        {
          begining ? null :
            <DashboardMenu tabs={tabsFiltrados} mode="learning" />
        }

        {loading && !erro ?
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ color: 'var(--jk-text)' }}>Carregando…</div>
          </div>
          : null}

        {erro ?
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '40px' }}>😅</div>
            <p style={{ color: 'var(--jk-text)', fontSize: '16px', margin: '10px 0 16px' }}>
              Ops! Não consegui carregar agora.
            </p>
            <button
              type="button"
              onClick={init}
              style={{
                background: 'var(--jk-primary)', color: '#fff', border: 'none',
                borderRadius: '14px', minHeight: '48px', padding: '0 26px',
                fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
              }}
            >
              🔄 Tentar de novo
            </button>
          </div>
          : null}

      </ContainerAuthenticated>
    </>
  );
} 